module.exports = new __parcel__URL__("earthshieldcancel.08d2dc74.png").toString();